import { render, staticRenderFns } from "./histroyEditor.vue?vue&type=template&id=c436dc52&scoped=true"
import script from "./histroyEditor.vue?vue&type=script&lang=js"
export * from "./histroyEditor.vue?vue&type=script&lang=js"
import style0 from "./histroyEditor.vue?vue&type=style&index=0&id=c436dc52&prod&lang=css"
import style1 from "./histroyEditor.vue?vue&type=style&index=1&id=c436dc52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c436dc52",
  null
  
)

export default component.exports